var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowRight1 = function SvgArrowRight1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Bold / Arrow / arrow-right-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-178.000000, -721.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(174.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5000018,12 C19.500819,12.6617023 19.2166089,13.2917013 18.72,13.729 L7.568,23.54 C6.79940904,24.1849293 5.65652679,24.098329 4.99389062,23.3449505 C4.33125444,22.591572 4.39124184,21.4469844 5.129,20.767 L14.881,12.188 C14.9351547,12.1405308 14.9662092,12.0720143 14.9662092,12 C14.9662092,11.9279857 14.9351547,11.8594692 14.881,11.812 L5.129,3.233 C4.39124184,2.55301564 4.33125444,1.40842796 4.99389062,0.655049482 C5.65652679,-0.0983289982 6.79940904,-0.184929277 7.568,0.46 L18.716,10.268 C19.213811,10.7060475 19.4993703,11.3369004 19.5000018,12 Z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right-1.b1e9c77cdcabe33ee68ed5d58d078c8d.svg";